export const referencesApiPaths = <const>{
    supportedCurrencies: 'references/supported-currencies',
    businessCountries: 'references/business-countries',
    personCountries: 'references/person-countries',
    personDocumentTypes: 'references/countries/:countryCode/person-document-types',
};
